<template>
  <card>
    <list
      v-if="$store.state.user.sections['partners']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {
        is_list: 1,
      },
      val: [],
      modalCreate: "season",
      fields: [
        // {
        //   col: ' col-12 col-md-12',
        //   key: "is_active",
        //   label: "Активность",
        //   type: "checkbox",
        // },
        {
          col: " col-12 col-md-6",
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "tin",
          label: "ИНН",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "phone",
          label: "Номер телефона",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "code",
          label: "Ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "type_auth",
          label: "Тип авторизации",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "api_secret_key",
          label: "Секретный ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "api_public_key",
          label: "Публичный ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "endpoint_url",
          label: "Endpoint URL",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_partner",
      itemLink: "partners",
      setLink: "partners",
      columns: [
        {
          key: "name",
          title: "Название",
        },
        {
          key: "is_active",
          title: "Активен",
        },
        {
          key: "code",
          title: "Ключ",
        },
        {
          key: "tin",
          title: "ИНН",
        },
        {
          key: "phone",
          title: "Контактный номер",
        },
        {
          key: "position",
          title: "Позиция",
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
